import { render, staticRenderFns } from "./CheckoutBooking.vue?vue&type=template&id=add3147e&"
import script from "./CheckoutBooking.vue?vue&type=script&lang=js&"
export * from "./CheckoutBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports